// modules/calendar/models/ExternAppointmentSchedule.ts
import { isNumber } from 'lodash'
import { Query } from '../../../common/api/Query'
import { WeekDay } from '../enums/WeekDay'

export type ExternAppointmentScheduleProps = {
  id?: string
  userId: string
  from: string
  to: string
  createdAt?: Date
  isActive?: boolean
  days: string
}

export class ExternAppointmentSchedule {
  private readonly _id: string | undefined
  private readonly _userId: string
  private _from: string
  private _to: string
  private readonly _createdAt: Date
  private _isActive: boolean
  private _days: string

  constructor(props: ExternAppointmentScheduleProps) {
    this._id = props.id
    this._userId = props.userId
    this._from = props.from
    this._to = props.to
    this._createdAt = props.createdAt || new Date()
    this._isActive = props.isActive !== undefined ? props.isActive : true
    this._days = props.days
  }

  get id(): string | undefined {
    return this._id
  }

  get userId(): string {
    return this._userId
  }

  get from(): string {
    return this._from
  }

  set from(value: string) {
    this._from = value
  }

  get to(): string {
    return this._to
  }

  set to(value: string) {
    this._to = value
  }

  get createdAt(): Date {
    return this._createdAt
  }

  get isActive(): boolean {
    return this._isActive
  }

  set isActive(value: boolean) {
    this._isActive = value
  }

  get days(): string {
    return this._days
  }

  set days(value: string) {
    this._days = value
  }

  get weekDays(): WeekDay[] {
    if (!this._days) return []

    if (!this._days.includes(',')) {
      const day = Number(this._days)
      if (!isNaN(day)) {
        return [day as WeekDay]
      }
      return []
    }

    const daysArray = this._days
      .split(',')
      .map((dayStr) => Number(dayStr.trim()))
      .filter((day) => !isNaN(day))

    return daysArray as WeekDay[]
  }
}
